import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/app/work/post/[slug]/error.tsx");
